import { actionTypes } from '../actions/searchBar'
import { actionTypes as actionTypesAdm } from '../actions/administrativeArea'

const initial = {
  operation_type: [],
  property_type: [],
  sub_property_type: '',
  sub_departamento_type: [],
  all_property_types: [],
  administrative_areas: [],
  all_administrative_areas:[],
  administrative_areas_selected: [],
  zona: '',
  ambients: [],
  bathrooms: [],
  garages: [],
  bedrooms: [],
  category: [],
  ubication: [],
  plant_type: [],
  terrain: [],
  avenue: [],
  focus: [],
  naves: [],
  unit_state: [],
  price_min: '',
  price_max: '',
  area_min: '',
  area_max: '',
  area_low_min: '',
  area_low_max: '',
  currency: '',
  show: false,
  originPath: { id:'' , name: '/' },
  originOffice: { id:'' , name: '' },
  searchFromMenu: false,
  is_new: '',
  is_professional_use: ''
}

export default (state = initial, action) => {
  switch (action.type) {

    case actionTypes.SAVE_ORIGIN_PATH: {
      return Object.assign({}, state, {
        originOffice: { id: '', name: '' },
        originPath: { id: action.value.id, name: action.value.name },
        // here we want to clear the searchbar state if the user
        // is changing of landing. e.g. go from home to retail
        ...( state.originPath.id !== action.value.id ? ({
          property_type: [],
          administrative_areas: [],
          sub_property_type: '',
          sub_departamento_type: [],
          administrative_areas_selected: [],
        }) : {}),
      })
    }

    case actionTypes.SAVE_ORIGIN_PATH_NO_RESET:
      return Object.assign({}, state, {
        originOffice: { id: '', name: '' },
        originPath: { id: action.value.id, name: action.value.name },
      })
    case actionTypes.SAVE_SUB_PROPERTY_TYPE:
      return Object.assign({}, state, {
        sub_property_type: action.sub_property_type
      })

    case actionTypes.ADD_SUB_TIPO_DEPARTAMENTO:
      var sub_departamento_type = state.sub_departamento_type.slice()
      sub_departamento_type.push(action.value)
      return Object.assign({}, state, {
        sub_departamento_type
      })

    case actionTypes.POP_SUB_TIPO_DEPARTAMENTO:
      var sub_departamento_type = state.sub_departamento_type.slice()
      sub_departamento_type.splice(sub_departamento_type.map(item => item.id).indexOf(action.value.id),1)
      return Object.assign({}, state, {
        sub_departamento_type
      })

    case actionTypes.SAVE_ORIGIN_OFFICE:
      var slug = action.value.name.replace(/\s/g, '').toLowerCase()
      return Object.assign({}, state, {
        originOffice: { id: action.value.id, name: slug, subsidiary: action.value.subsidiary },
        originPath: { id: 6, name: 'Residencial' }
    })

    case actionTypes.RECEIVE_ALL_PROPERTY_TYPES:
      return Object.assign({}, state, {
        all_property_types: action.property_types
      })

    case actionTypes.SET_OPERACION:
      var operation_type = []
      operation_type.push(action.value)
      return Object.assign({}, state, { operation_type })

    case actionTypes.SET_PROPERTY_TYPE:
      var property_type = []
      property_type.push(action.value)
      return Object.assign({}, state, { property_type })

    case actionTypes.SET_AMBIENTS:
      var ambients = []
      ambients.push(action.value)
      return Object.assign({}, state, { ambients })

    case actionTypes.SET_BATHS:
      var bathrooms = []
      bathrooms.push(action.value)
      return Object.assign({}, state, { bathrooms })

    case actionTypes.SET_GARAGES:
      var garages = []
      garages.push(action.value)
      return Object.assign({}, state, { garages })

    case actionTypes.SET_ROOMS:
      var bedrooms = []
      bedrooms.push(action.value)
      return Object.assign({}, state, { bedrooms })

    case actionTypes.SET_NAVES:
      var naves = []
      naves.push(action.value)
      return Object.assign({}, state, { naves })

    case actionTypes.SET_TERRAIN:
      let lands = []
      lands.push(action.value)
      return Object.assign({}, state, {
        terrain: lands
    })

    case actionTypes.SET_CATEGORY:
      let categories = []
      if(action.value.id != '') categories.push(action.value)
      return Object.assign({}, state, {
        category: categories
    })

    case actionTypes.SET_PLANT:
      let plants = []
      if(action.value.id != '') plants.push(action.value)
      return Object.assign({}, state, {
        plant_type: plants
    })

    case actionTypes.SET_AVENUE:
    let avenues = []
    if (action.value.name !== '-') {
      avenues.push(action.value)
    }
    return Object.assign({}, state, {
      avenue: avenues
    })

    case actionTypes.SET_FOCUS:
      let focus = []
      if (action.value.name !== '-') {
        focus.push(action.value)
      }
      return Object.assign({}, state, {
        focus: focus
    })

    case actionTypes.SET_UBICATION:
      let ubication = []
      ubication[0] = action.value
      return Object.assign({}, state, {
        ubication: ubication
    })

    case actionTypes.SET_UNIT_STATE:
      let unit_state = []
      unit_state[0] = action.value
      return Object.assign({}, state, {
        unit_state: unit_state
    })

    //from menu, a list of ids

    case actionTypes.ADD_PROPERTY_TYPE:
      var property_type = []
      property_type.push(action.value)
      return Object.assign({}, state, { property_type })

    case actionTypes.ADD_OPERATION_TYPE:
      if (Array.isArray(action.value))
        operation_type = action.value
      else
        operation_type = [action.value]
      return Object.assign({}, state, { operation_type })

    case actionTypes.ADD_AMBIENTS:
      var ambients = state.ambients.slice()
      var n = action.n
      var deleted = false
      for (var i = ambients.length - 1; i >= 0; i--){
        if (JSON.stringify(ambients[i]) === JSON.stringify(n)){
           ambients.splice(i, 1)
           deleted = true
        }
      }
      if (!deleted){
        ambients.push(action.n)
      }
      return Object.assign({}, state, { ambients })

    //TODO - ver si hay que cambiar rooms por bedrooms o ambients
    case actionTypes.ADD_BATHROOMS:
      var bathrooms = state.bathrooms.slice()
      var n = action.n
      var deleted = false
      for (var i = bathrooms.length - 1; i >= 0; i--){
        if (JSON.stringify(bathrooms[i]) === JSON.stringify(n)){
           bathrooms.splice(i, 1)
           deleted = true
        }
      }
      if (!deleted){
        bathrooms.push(action.n)
      }
      return Object.assign({}, state, { bathrooms })

    case actionTypes.ADD_GARAGES:
      var garages = state.garages.slice()
      var n = action.n
      var deleted = false
      for (var i = garages.length - 1; i >= 0; i--){
        if (JSON.stringify(garages[i]) === JSON.stringify(n)){
           garages.splice(i, 1)
           deleted = true
        }
      }
      if (!deleted){
        garages.push(action.n)
      }
      return Object.assign({}, state, { garages })

    case actionTypes.ADD_BEDROOMS:
      var bedrooms = state.bedrooms.slice()
      var n = action.n
      var deleted = false
      for (var i = bedrooms.length - 1; i >= 0; i--){
        if (JSON.stringify(bedrooms[i]) === JSON.stringify(n)){
           bedrooms.splice(i, 1)
           deleted = true
        }
      }
      if (!deleted){
        bedrooms.push(action.n)
      }
      return Object.assign({}, state, { bedrooms })

    case actionTypes.ADD_NAVES:

      var naves = state.naves.slice()
      var n = action.n
      var deleted = false
      for (var i = naves.length - 1; i >= 0; i--){
        if (JSON.stringify(naves[i]) === JSON.stringify(n)){
           naves.splice(i, 1)
           deleted = true
        }
      }
      if (!deleted){
        naves.push(action.n)
      }
      return Object.assign({}, state, { naves })

    case actionTypes.SET_AREA_MIN:
      let area_min = action.value
      if (action.value === '-') {
        area_min = ''
      }
      return Object.assign({}, state, {
        area_min: area_min
    })

    case actionTypes.SET_AREA_MAX:
      let area_max = action.value
      if (action.value === '-') {
        area_max = ''
      }
      return Object.assign({}, state, {
        area_max: area_max
    })

    case actionTypes.SET_AREA_MIN_LOW:
      let area_min_low = action.value
      if (action.value === '-') {
        area_min_low = ''
      }
      return Object.assign({}, state, {
        area_low_min: area_min_low
    })

    case actionTypes.SET_AREA_MAX_LOW:
      let area_max_low = action.value
      if (action.value === '-') {
        area_max_low = ''
      }
      return Object.assign({}, state, {
        area_low_max: area_max_low
    })

    case actionTypes.SET_PRICE_MIN:
      return Object.assign({}, state, {
        price_min: action.value
    })

    case actionTypes.SET_PRICE_MAX:
      return Object.assign({}, state, {
        price_max: action.value
    })

    case actionTypes.CHANGE_CURRENCY:
      let currency = action.value
      if (action.value == null) {
        currency = ''
      }
      return Object.assign({}, state, {
        currency: currency
    })

    case actionTypes.ADD_ADMINISTRATIVEAREA:
      var administrative_areas_selected = action.value
      return Object.assign({}, state, { administrative_areas_selected })

    case actionTypesAdm.RECEIVE_ADMINISTRATIVEAREAS:
      var administrative_areas = action.list
      return Object.assign({}, state, { administrative_areas })

      case actionTypesAdm.RECEIVE_ALL_ADMINISTRATIVEAREAS:
        var all_administrative_areas = action.list
        return Object.assign({}, state, { all_administrative_areas })

    case actionTypes.ADD_TIPO_PROPIEDAD:
      var property_type = state.property_type
      var id = action.value
      var index = property_type.indexOf(id);
      ( index == -1 ) ? property_type.push(action.value) : property_type.splice(index, 1)
      return Object.assign({}, state, { property_type })

    case actionTypes.CHANGE_PROFESSIONAL_USE:
      return Object.assign({}, state, {
        is_professional_use: !state.is_professional_use
    })

    case actionTypes.CHANGE_NEW:
      return Object.assign({}, state, {
        is_new: !state.is_new
    })

    case actionTypes.TOGGLE_PANEL:
      return Object.assign({}, state, {
        show: !state.show
    })

    case actionTypes.SEARCH_FROM_MENU:
      return Object.assign({}, state, {
        searchFromMenu: true
    })

    case actionTypes.SEARCH_FROM_SEARCHBAR:
      return Object.assign({}, state, {
        searchFromMenu: false
    })

    case actionTypes.CHECK_OPERATION_TYPE:
      var operation_type = state.operation_type.slice()
      if (operation_type.length === 0){
        var elem = { id:1, name: 'Venta' }
        operation_type.push(elem)
      }
      return Object.assign({}, state, { operation_type })

    case actionTypes.RESET_FORM:
      return Object.assign({}, state, {
        ambients: ['-'],
        bathrooms: ['-'],
        garages: ['-'],
        bedrooms: ['-'],
        category: [],
        terrain: [],
        focus: [],
        avenue: [],
        price_min: '',
        price_max: '',
        area_min: '',
        area_max: '',
        area_low_min: '',
        area_low_max: '',
    })

    case actionTypes.RESET_FILTERS:
      return Object.assign({}, state, {
        administrative_areas: [],
        zona: '',
        ambients: [],
        bathrooms: [],
        garages: [],
        bedrooms: [],
        category: [],
        ubication: [],
        plant_type: [],
        terrain: [],
        avenue: [],
        focus: [],
        naves: [],
        unit_state: [],
        price_min: '',
        price_max: '',
        area_min: '',
        area_max: '',
        area_low_min: '',
        area_low_max: '',
        is_new: '',
        is_professional_use: '',
        currency: ''
    })

    case actionTypes.RESET_SUB_DEPARTAMENTO_TYPE:
      return Object.assign({}, state, {
        sub_departamento_type: []
      })

    case actionTypes.RESET_SUB_PROPERTY_TYPE:
      return Object.assign({}, state, {
        sub_property_type: ''
      })

    case actionTypes.RESET_PROPERTY_TYPE:
      return Object.assign({}, state, {
        property_type: []
      })

    case actionTypes.LOAD_PARAMS_FROM_URL:
      let st = {...state}
      let params = action.data

      if (params.operation_type_id)
        st.operation_type = params.operation_type_id.slice().map(id => ({id}))

      if (params.property_type_id)
        st.property_type = params.property_type_id.slice().map(id => ({id}))

      if (params.administrative_areas)
        st.administrative_areas_selected = params.administrative_areas.slice().map(value => ({value, zone: false}))

      let ops = [
        { id: '', name: '/'},
        { id: '1', name: 'Oficina'},
        { id: '2', name: 'Industrias'},
        { id: '3', name: 'Locales'},
        { id: '6', name: 'Residencial'},
        { id: '7', name: 'Terrenos'},
        { id: '8', name: 'Emprendimientos'},
        { id: '9', name: 'Campos'},
        // HIDE-HOTELS { id: '13', name: 'Hoteles'},
      ]
      if (params.category_type_id) {
        let found = ops.find(val => val.id==params.category_type_id)
        if (found) st.originPath = {id: found.id, name: found.name}
      }

      if (params.price_min) st.price_min = params.price_min
      if (params.price_max) st.price_max = params.price_max
      if (params.area_min) st.area_min = params.area_min
      if (params.area_max) st.area_max = params.area_max
      if (params.currency_type_id) st.currency = params.currency_type_id
      return st

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/searchBar.js